// Deflect Analytics endpoints, one per section.
//
// Only the lookups list is live (it is the Receipt page's own). The rest is still mocked against
// docs/temp/deflect-analytics-backend-tz.md; the real request sits commented out above each
// mock, so switching over is uncommenting it, deleting the mock line, and adding:
//
//   import { request } from "../../../Services/Api"
import { getReceiptLookups } from "../../ReceiptPage/api/services"
import * as mock from "./mock.data"

// apisauce shape after a network-like pause, so the section spinners and the slice's
// stale-response guard run the way they will against the real endpoints.
const mockResponse = (data) =>
  new Promise((resolve) => {
    setTimeout(() => resolve({ ok: true, status: 200, data }), 300 + Math.random() * 500)
  })

export const getDeflectKpis = (params) =>
  // request.api.get("/consumer-clarity/analytics/kpis/", params)
  mockResponse(mock.getKpis(params))

export const getDeflectTrend = (params) =>
  // request.api.get("/consumer-clarity/analytics/trend/", params)
  mockResponse(mock.getTrend(params))

export const getDeflectQueue = (params) =>
  // request.api.get("/consumer-clarity/analytics/queue/", params)
  mockResponse(mock.getQueue(params))

export const getDeflectFlow = (params) =>
  // request.api.get("/consumer-clarity/analytics/flow/", params)
  mockResponse(mock.getFlow(params))

export const getDeflectByChannel = (params) =>
  // request.api.get("/consumer-clarity/analytics/by-channel/", params)
  mockResponse(mock.getByChannel(params))

export const getDeflectByCountry = (params) =>
  // request.api.get("/consumer-clarity/analytics/by-country/", params)
  mockResponse(mock.getByCountry(params))

export const getDeflectByProgram = (params) =>
  // request.api.get("/consumer-clarity/analytics/by-program/", params)
  mockResponse(mock.getByProgram(params))

export const getDeflectMatchRateMatrix = (params) =>
  // request.api.get("/consumer-clarity/analytics/match-rate-matrix/", params)
  mockResponse(mock.getMatchRateMatrix(params))

export const getDeflectRepeatCardholders = (params) =>
  // request.api.get("/consumer-clarity/analytics/repeat-cardholders/", params)
  mockResponse(mock.getRepeatCardholders(params))

export const getDeflectChannelTrends = (params) =>
  // request.api.get("/consumer-clarity/analytics/channel-trends/", params)
  mockResponse(mock.getChannelTrends(params))

// Receipt's dashboard/lookups/ takes one program or "all" (a CSV of both is a 400) and the window
// as a single "<from>,<to>" datetime pair, the way the Receipt filter bar sends it.
export const getDeflectLookups = ({ start_date, end_date, program, ...params }) =>
  getReceiptLookups({
    ...params,
    program: program && !program.includes(",") ? program : "all",
    ...(start_date && end_date ? { date: `${start_date}T00:00:00Z,${end_date}T23:59:59Z` } : {})
  })
